import $ from 'jquery';
import 'slick-carousel';

/**
 * Model Overview "Explore the <Model>" slider
 * (views/oem/parts/landing/templates/_model-rotator.twig).
 *
 * Same data-slider + controls pattern as the showroom collection sliders: slick centre mode with the
 * neighbouring slides peeking in (click one to centre it), dots, no arrows.
 */
const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

$('.model-rotator__slider').each(function () {
  const sliderID = $(this).data('slider');
  const $slider = $(`.${sliderID}`);

  $slider.on('init', function (event, slick) {
    if (slick.$dots) {
      const dots = slick.$dots.find('li');
      const theme = $(`.controls-dots-${sliderID}`).data('theme');
      dots.addClass('slick-dot ' + theme);
    }
  });

  $slider.slick({
    centerMode: true,
    centerPadding: '20%',
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: true,
    infinite: true,
    arrows: false,
    dots: true,
    autoplay: !reduceMotion,
    autoplaySpeed: 4500,
    pauseOnHover: true,
    pauseOnFocus: true,
    appendDots: $(`.controls-dots-${sliderID}`),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerPadding: '12%',
        },
      },
    ],
  });
});
